/**
 * Command palette (Cmd-K) — Learn-Mode inline tips (lane B6).
 *
 * Anchored in `components/command-palette/CommandPalette.tsx`.
 */

import type { LearnTip } from "./types";

export const commandPaletteTips: LearnTip[] = [
  {
    key: "social-command-palette",
    title: "Quick search",
    body: "Jump to any page, start a new post or design, switch client, or find a post, design or content idea by typing a few words.",
    bullets: ["Shortcut: Cmd+K on a Mac, Ctrl+K on Windows.", "Use the arrow keys and Enter to pick; Esc closes."],
  },
];
